<template>
  <div>
    <button
      :disabled="backDisabled"
      class="btn btn-default"
      @click="backNavigation"
    >
      <i class="fa fa-chevron-left icon-reset" />
      Back
    </button>
  </div>
</template>
<script>
export default {
    name: 'MagBackNav',
    props: {
        backPath: {
            type: String,
            default: '/'
        },
        backDisabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        backNavigation: function () {
            this.$router.push(this.backPath)
        }
    }
}
</script>
